import React, { FC, useState } from 'react';
import { Add } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';

import { PatchesName } from '../../../helpers/types';
import { AddUserModal } from './AddUserModal';

const TitleUsers: FC = () => {
  const navigate = useNavigate();
  const [isModalRemove, setIsModalRemove] = useState(false);

  const handlerOpenModal = () => {
    setIsModalRemove(true);
  };

  return (
    <Box mb={5} width="100%" display="flex" justifyContent="space-between">
      <Box pl={2} display="flex">
        <Typography fontSize="1.7em" textTransform="none" color="#262626">
          Пользователи
        </Typography>
      </Box>
      <Box display="flex">
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={handlerOpenModal}
          sx={{
            '&': {
              borderRadius: '10px',
              height: '50px',
              color: '#fff',
              bgcolor: '#5269A3',
            },
          }}
        >
          <Typography color="#e5e5e5" fontSize="14px">
            Добавить пользователя
          </Typography>
        </Button>
      </Box>
      {isModalRemove && <AddUserModal closeModal={() => setIsModalRemove(false)} />}
    </Box>
  );
};

export default TitleUsers;
